/**
 * Códigos de plan/cuota devueltos por APIs Structura (402/403), más
 * "hidden_by_niche" — SCRUM-451: no es un código de API (el backend nunca lo
 * emite en HTTP), es sintetizado client-side cuando isFeatureApplicableToNiche
 * determina que la feature no aplica al business_profile del tenant. Un
 * distingo real: ningún upgrade de plan resuelve esto, así que
 * FeatureLockedState no debe ofrecer CTA de upgrade para este código.
 */
export type PlanApiErrorCode = "plan_limit_reached" | "plan_feature_locked" | "quota_exceeded" | "hidden_by_niche";

export interface PlanApiErrorPayload {
  message: string;
  code: PlanApiErrorCode;
  feature?: string;
  limit?: number;
  current?: number;
}

export function parsePlanApiError(data: unknown): PlanApiErrorPayload | null {
  if (!data || typeof data !== "object") return null;
  const d = data as Record<string, unknown>;
  const code = d.code;
  if (code !== "plan_limit_reached" && code !== "plan_feature_locked" && code !== "quota_exceeded") {
    return null;
  }
  return {
    message: typeof d.error === "string" ? d.error : "Función no disponible en tu plan",
    code,
    feature: typeof d.feature === "string" ? d.feature : undefined,
    limit: typeof d.limit === "number" ? d.limit : undefined,
    current: typeof d.current === "number" ? d.current : undefined,
  };
}
